import { createContext, ReactNode, Dispatch, SetStateAction } from 'react';
import { CustomerApiRecord, LinkedId } from '../../api/customer/types';

export type CustomerApi = {
  customer: CustomerApiRecord | Record<string, any>;
  setCustomer: Dispatch<SetStateAction<CustomerApiRecord | undefined>>;
  linkedId: LinkedId;
  loading: boolean;
  error?: boolean;
};

export const CustomerApi = createContext<CustomerApi>({
  customer: null,
  setCustomer: () => undefined,
  linkedId: null,
  loading: false,
  error: true,
});

export type CustomerApiProviderProps = {
  children: ReactNode;
  linkedId: LinkedId;
};
